import o from"lodash/cloneDeep";import r from"lodash/merge";var e={baseColors:["#6f2936","#15a1bf"]},a=function(a){return r(o(e),o(a))};export{e as FUNNEL_CHART_DEFAULT_CONFIG,e as default,a as mergeFunnelChartConfigs};
